export const SET_GOOGLE_ADDRESS = "SET_GOOGLE_ADDRESS";
export const GET_GOOGLE_ADDRESS = "GET_GOOGLE_ADDRESS";


// WEBPACK FOOTER //
// ./src/types/googleActionTypes.js